import styled from "styled-components";
import { fadeIn } from "sweet-web/lib/animations";
import { MAX_WIDTH } from "sweet-web/lib/constants";
import { colors } from "sweet-web/lib/styles";

export const Form = styled.form`
  ${fadeIn}
  padding: 40px 0;
  width: 350px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    width: 100%;
  }
`;

export const Section = styled.div<{ width?: number }>`
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  border-top: 1px solid ${colors.lighterGray};
  &:first-of-type {
    border-top: none;
  }
  ${fadeIn}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: ${MAX_WIDTH}px;
  padding-bottom: 60px;
`;

export const Indent = styled.div`
  margin: 20px 0;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  border-left: 1px solid ${colors.gray};
  ${fadeIn}
`;

export const OptionWrapper = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
